// Vocabulário de TOM dos insights: o dado diz o que significa ("isto é um
// alerta"), não que cor usar. Assim a paleta muda num lugar só, e a fonte do
// número (hoje mocada, amanhã uma API) nunca carrega hex.
export const TONS = {
  POSITIVO: 'positivo',
  ALERTA: 'alerta',
  CRITICO: 'critico',
  NEUTRO: 'neutro',
  // Faixas secundárias do `hero`: o mesmo verde, mais apagado, para as fatias
  // que compõem o total sem competir com a principal.
  POSITIVO_MEDIO: 'positivo-medio',
  POSITIVO_FRACO: 'positivo-fraco',
}

// ⚠️ NUNCA usar `warning-new` aqui: é só variável SASS e fica de fora dos mapas
// que o `:root` percorre, então `var(--warning-new)` não resolve e o elemento
// sai SEM COR. O amarelo exportado como custom property é o `--warning-text`.
// Armadilha já documentada no CLAUDE.md do fee-fixo.
const TOKEN_POR_TOM = {
  [TONS.POSITIVO]: 'var(--success)',
  [TONS.POSITIVO_MEDIO]: 'var(--success-bg-soft)',
  [TONS.POSITIVO_FRACO]: 'var(--success-bg-soft)',
  [TONS.ALERTA]: 'var(--warning-text)',
  [TONS.CRITICO]: 'var(--danger-text)',
  [TONS.NEUTRO]: 'var(--neutral-300)',
}

/**
 * Tom → custom property. Tom desconhecido cai no neutro em vez de devolver
 * `undefined`, que viraria elemento sem cor nenhuma na tela.
 * @param {string} tom
 * @returns {string} valor CSS pronto
 */
export const tokenDoTom = (tom) =>
  TOKEN_POR_TOM[tom] || TOKEN_POR_TOM[TONS.NEUTRO]
